import { render, staticRenderFns } from "./WxLossDetermPanel.vue?vue&type=template&id=0bc00e76&scoped=true&"
import script from "./WxLossDetermPanel.vue?vue&type=script&lang=js&"
export * from "./WxLossDetermPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc00e76",
  null
  
)

export default component.exports